import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewEncapsulation,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-decisionsenddialog",
  templateUrl: "decisionsenddialog.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .validate-lb .modal-full .modal-body {
        color: #00001f;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
      }
      .validate-lb .modal-full .h2-eq {
        margin-bottom: 32px;
      }
      .btn-validate {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 2px;
        padding: 12px 24px;
        background-color: #2d81ff;
        color: #ffffff;
        border-radius: 24px;
        margin-top: 16px;
        margin-right: 16px;
      }
      .btn-validate:disabled {
        background-color: #c9c9db;
      }
      .btn-validate {
        background-color: #ffffff;
        color: #00001f;
        border: 1px solid #c9c9db;
      }
    `,
  ],
})
export class DecisionSendDialogComponent implements OnInit, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @ViewChild("content", { static: true }) content;
  @ViewChild("closeBtn") closeBtn?: ElementRef<HTMLButtonElement>;
  @ViewChild("sendBtn") sendBtn?: ElementRef<HTMLButtonElement>;
  @ViewChild("resultBtn") resultBtn?: ElementRef<HTMLButtonElement>;
  @Input() negativeCashLeft: number;
  @Input() texts: any;
  @Input() displayCancelConfirm: boolean = false;
  @Output() validated: EventEmitter<string> = new EventEmitter();
  subs = new SubSink();
  dialogHeadingId = "dsd-heading";
  cssColor: string;
  modalReference: any;
  isDemo = false;
  runModelEnded = false;
  productStates = {};
  allValidated: boolean;
  decisionSent: boolean;
  decisionConfirmed: boolean;

  get currentHeading(): string {
    if (this.decisionConfirmed) {
      if (!this.isDemo) return this.texts?.thankYouText ?? "";
      return this.runModelEnded
        ? (this.texts?.modelHasRunText ?? "")
        : (this.texts?.modelRunningText ?? "");
    }
    if (this.decisionSent && this.negativeCashLeft !== 0)
      return this.texts?.negativeCashLeft1Text ?? "";
    return this.texts?.isDecisionDoneText ?? "";
  }

  private focusActive(): void {
    if (this.decisionConfirmed && this.runModelEnded) {
      this.resultBtn?.nativeElement.focus();
    } else if (this.decisionConfirmed || this.decisionSent) {
      this.closeBtn?.nativeElement.focus();
    }
  }

  constructor(
    private configurationService: ConfigurationService,
    private modalService: NgbModal,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        thisObject.isDemo = c.isDemo;
      },
    );
  }

  oncheckboxchange(product: string) {
    if (this.productStates[product] === true) {
      this.productStates[product] = false;
    } else {
      this.productStates[product] = true;
    }

    this.allValidated = false;
    if (
      Object.keys(this.productStates).length === this.texts.productNames.length
    ) {
      this.allValidated = true;
      for (const propertyName in this.productStates) {
        if (!this.productStates[propertyName]) {
          this.allValidated = false;
        }
      }
    }
  }

  sendDecision() {
    if (this.displayCancelConfirm && this.negativeCashLeft !== 0) {
      this.decisionSent = true;
    } else {
      this.decisionSent = true;
      this.decisionConfirmed = true;
      this.validated.emit("decision validated");
    }
    setTimeout(() => this.focusActive());
  }

  confirmDecision() {
    this.decisionConfirmed = true;
    this.validated.emit("decision validated");
    setTimeout(() => this.focusActive());
  }

  ngOnInit() {}

  open() {
    if (this.texts?.productNames?.length === 1) {
      this.decisionSent = true;
      this.decisionConfirmed = true;
      this.validated.emit("decision validated");
    }
    this.modalReference = this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "modal-full modal-dialog-scrollable",
      size: "xl",
      backdrop: "static",
      keyboard: false,
    });
    setTimeout(() => this.focusActive());
  }

  modelHasRun() {
    this.runModelEnded = true;
    setTimeout(() => this.focusActive());
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
